<template>

  <v-alert v-if="end && Temporal.PlainDate.compare(today, end) === -1" icon="$alert" color="info" class="mb-6">
    <template v-slot:text>
      The selected date range extends into the future. Data may be unavailable for this tab.
    </template>
  </v-alert>

</template>

<script setup lang="ts">

import { Temporal } from '@js-temporal/polyfill'

interface Props {
  end: null | Temporal.PlainDate
}

defineProps<Props>()

const today = Temporal.Now.plainDateISO()

</script>
